import styled from 'styled-components'
import { isMobile } from 'react-device-detect'
import { greys, borderRadius } from 'assets/themes/theme-default'
import { Radio } from '../index'

const RadioButton = styled(Radio.Button)`
  &&& {
    margin: ${isMobile ? '0px 5px 15px' : '10px 12px 10px 0'};
    padding: ${isMobile ? '0 15px ' : '0 20px'};
    border-radius: ${borderRadius.base};

    background-color: transparent;
    border-color: ${greys.dark4};
    border-width: 1px;
    border-left: 1px solid ${greys.dark4};
    text-align: center;
    span:not(.ant-radio-button) {
      color: ${greys.dark1};
    }
    &.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
      background-color: ${props => props.theme.colors.color1.bg};
      border-color: ${props => props.theme.colors.color1.bg};
      color: ${greys.light4};
      box-shadow: none;
      span:not(.ant-radio-button) {
        color: ${greys.light4};
      }
    }

    ::before {
      display: none;
    }
  }
`
export default RadioButton
